const xwx = [
  {
    path: '/',
    name: 'home',
    component: () => import("../views/home/index.vue"),
    meta: { title: "NC-Link社区-首页" }
  },
  {
    path: '/newhome',
    name: 'newhome',
    component: () => import("../views/newHome/index.vue"),
    meta: { title: "NC-Link社区-首页" }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue")
  },
  {
    path: "/layout",
    name: "layout",
    redirect: 'company',
    component: () => import("../views/layout/index"),
    children: [
      {
        path: '/homepage',
        component: () => import('../views/backstage/homepage/index'),
        name: '个人中心',
        meta: { title: '个人中心', icon: 'dashboard', affix: true }
      },
      {
        path: '/company',
        name: '应用软件',
        component: () => import('../views/backstage/company/index'),
        meta: { title: '应用软件', icon: 'dashboard', affix: true }
      },
      {
        path: '/product',
        component: () => import('@/views/backstage/product/index'),
        name: '开源软件',
        meta: { title: '开源软件', icon: 'dashboard', affix: true }
      },
      {
        path: '/industry',
        component: () => import('@/views/backstage/industry/index'),
        name: '应用硬件',
        meta: { title: '应用硬件', icon: 'dashboard', affix: true }
      },
      {
        path: '/tool',
        component: () => import('@/views/backstage/tool/index'),
        name: '机床列表',
        meta: { title: '机床列表', icon: 'dashboard', affix: true }
      },
      {
        path: '/processing',
        component: () => import('@/views/backstage/processing/index'),
        name: '工艺列表',
        meta: { title: '工艺列表', icon: 'dashboard', affix: true }
      },
      {
        path: '/dispose',
        component: () => import('@/views/backstage/dispose/index'),
        name: '表面处理列表',
        meta: { title: '表面处理列表', icon: 'dashboard', affix: true }
      },
      {
        path: '/xpolicy',
        component: () => import('@/views/backstage/policy/index'),
        name: '论坛',
        meta: { title: '论坛', icon: 'dashboard', affix: true }
      },
      {
        path: '/collection',
        component: () => import('@/views/backstage/collection/index'),
        name: '代码管理',
        meta: { title: '代码管理', icon: 'dashboard', affix: true }
      },
      {
        path: '/technical',
        component: () => import('@/views/backstage/technical/index'),
        name: '技术交流',
        meta: { title: '技术交流', icon: 'dashboard', affix: true }
      },
      {
        path: '/user',
        component: () => import('@/views/backstage/user/index'),
        name: '用户列表',
        meta: { title: '用户列表', icon: 'dashboard', affix: true }
      },
      {
        path: '/statistics',
        component: () => import('@/views/backstage/statistics/index'),
        name: '统计',
        meta: { title: '统计', icon: 'dashboard', affix: true }
      },
      {
        path: '/supplyx',
        component: () => import('@/views/backstage/supply/index'),
        name: 'MCP令牌',
        meta: { title: 'MCP令牌', icon: 'dashboard', affix: true }
      },
      {
        path: '/capax',
        component: () => import('@/views/backstage/capa/index'),
        name: '产能列表',
        meta: { title: '产能列表', icon: 'dashboard', affix: true }
      },
      {
        path: '/mro',
        component: () => import('@/views/backstage/mro/index'),
        name: 'mro列表',
        meta: { title: 'mro列表', icon: 'dashboard', affix: true }
      },
      {
        path: '/parameter',
        component: () => import('@/views/backstage/parameter/index'),
        name: '开源硬件',
        meta: { title: '开源硬件', icon: 'dashboard', affix: true }
      }
    ]
  }

]
export default xwx;